import api from "../../system/api";

export default class UserSession {
    async getAll() {
        const {data} = await api.get("/user-sessions");
        return data?.data || [];
    }

    async getCurrent() {
        const {data} = await api.get("/user-sessions/current");
        return data?.data || null;
    }

    async revoke(documentId) {
        const {data} = await api.delete(`/user-sessions/${documentId}`);
        return data?.data;
    }

    async revokeOthers() {
        const {data} = await api.post("/user-sessions/revoke-others");
        return data?.data;
    }

    async revokeAll() {
        const {data} = await api.post("/user-sessions/revoke-all");
        return data?.data;
    }

    async changePassword(payload) {
        const {data} = await api.post("/auth/change-password", payload);
        return data;
    }
}
